import { gql } from '@apollo/client';

export default gql`
  mutation processCardPrrRefund(
    $bookingReference: String!
    $paymentLocation: String!
    $pspReference: String
    $refundAmount: Float!
    $currency: Currency!
    $hasHotel: Boolean
    $additionalDetails: [InputAdditionalDetails!]!
    $compensationRecordsToUpdate: [InputCompensationRecordToUpdate]
  ) {
    processCardPrrRefund(
      bookingReference: $bookingReference
      paymentLocation: $paymentLocation
      pspReference: $pspReference
      refundAmount: $refundAmount
      currency: $currency
      hasHotel: $hasHotel
      location: EBSC
      additionalDetails: $additionalDetails
      compensationRecordsToUpdate: $compensationRecordsToUpdate
    ) {
      bookingReference
      updatedCompensationRecords
    }
  }
`;
